import Swiper, {Autoplay, Navigation, EffectFade} from "swiper";
import {fromEvent} from "rxjs";
import {map, startWith, tap} from "rxjs/operators";
import tippy from "tippy.js";

export const initMapItemsCarouselSwiper = (swiperSelector, mapItemsContainerSelector, tips) => {
    Swiper.use([Autoplay, EffectFade, Navigation]);
    if(jQuery(swiperSelector).length == 0){
        return;
    }
    let swiper;
    swiper = new Swiper(swiperSelector, {
        autoplay: {
            delay: 6000,
            disableOnInteraction: false
        },
        loop: true,
        speed: 800,
        effect: 'fade',
        fadeEffect:{
            crossFade: true
        },
        navigation: {
           nextEl: ".swiper-next",
           prevEl: ".swiper-prev"
        },
        spaceBetween: 40,
        allowSlidePrev: true,
        allowTouchMove: true
    });

    //fromEvent(jQuery('.testimonials-c0 .thumb-c0'), 'mouseenter').pipe(
    let mapItemsContainer = jQuery(mapItemsContainerSelector);
    fromEvent(mapItemsContainer.children(), 'mouseenter').pipe(
        map( e => jQuery(e.currentTarget).index()),
        tap(e => {
            console.log(e);
            swiper.slideToLoop(e, 800)
        })
    ).subscribe();


    /* fromEvent(swiper, 'slideChangeTransitionStart').pipe(
         tap( e => console.log(e) )
     ).subscribe();*/
    fromEvent(swiper, 'slideChangeTransitionStart').pipe(
        map( e => swiper.realIndex ),
        startWith(0),
        tap( e => {

            /*let wasActive: any = jQuery('.map-point.active');
            console.log(wasActive);
            // wasActive.destroy();
            wasActive.map((t: any)=> t.destroy());*/
            mapItemsContainer.children().each( (index, elem) => {
                if (jQuery(elem).hasClass('active')) {
                    tips[index].hide();
                }
            });
            mapItemsContainer.children().removeClass('active');
            mapItemsContainer.children().eq(e).addClass('active');
           /* let active: any = mapItemsContainer.children().eq(e).get(0);
            console.log('active', active);
            //active._tippy.show()
            tippy(active, {
                arrow: true,
                animation: 'scale',
                theme: 'custom',
                zIndex: 10,
                hideOnClick: false,
                trigger: 'manual'
            });*/
            // (tippy('.map-point') as any).hide()
            tips[e].show();
            // active._tippy.show();
        })
    ).subscribe();
}
